module.exports = __webpack_public_path__ + "img/5.ca303556.jpg";